import cx from 'classnames';
import React from 'react';

import { EditAppearanceControls } from './edit-appearance-controls';

type EditAppearancePanelProps = {
  disabled?: boolean;
  scrollLocked?: boolean;
};

export const EditAppearancePanel = ({
  disabled = false,
  scrollLocked = false,
}: EditAppearancePanelProps) => {
  const overflowClass =
    scrollLocked || disabled ? 'overflow-hidden' : 'overflow-y-auto';

  return (
    <div
      className={cx(
        'flex h-full flex-col [scrollbar-width:thin] [scrollbar-color:#696e7c_transparent]',
        overflowClass,
        disabled && 'pointer-events-none opacity-60',
      )}
      {...(disabled && { 'aria-disabled': true })}
    >
      <EditAppearanceControls disabled={disabled} />
    </div>
  );
};
